<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-12 09:19:02
 * @LastEditTime: 2022-04-01 17:12:26
-->
<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        v-if="Permission.indexOf(233) !== -1"
        type="primary"
        size="mini"
        @click="addDevice"
        >{{ $t("lang.Button.Add") }}</el-button
      >
      <!-- <el-button type="danger" size="mini" @click="batchDelete">批量删除</el-button> -->
      <el-button
        v-if="this.seek.gid"
        type="primary"
        size="mini"
        @click="goBack"
        >{{ $t("lang.particulars.WAD_NUMBER_RETURN") }}</el-button
      >
    </div>
    <TableComponent
      :Columns="Columns"
      ref="devicesTable"
      :data="deviceList"
      :ColuumnsButton="ColuumnsButton"
      :ColuumnsButtonWidth="240"
      @GetStatus="GetStatus"
      @showDetail="showDetail"
      @handleSelectionChange="handleSelectionChange"
      @deleteDevice="deleteDevice"
      @sortChange="sortChange"
      @showVariable="showVariable"
      :seek="seek"
    >
      <span
        slot="slot"
        slot-scope="scope"
        style="color:#409eff;font-size:15px;"
        >{{ scope.scope.$index }}</span
      >
    </TableComponent>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 添加编辑 -->
    <add-device ref="addDevice" @updateList="queryKeyword"></add-device>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
import TableComponent from "@/components/TableComponent/index";
import { Columns, ColuumnsButton } from "./tableConfig";
import {
  getListByGroup,
  deleteDevice,
  queryDevices,
} from "@/api/cloudMonitor/deviceList";
import addDevice from "./components/addDevice";
import { mapGetters } from "vuex";
import { getPermission } from "@/cookie/cookie";
export default {
  name: "CloudMonitorDeviceList",
  components: {
    TableComponent,
    pagination,
    addDevice,
  },
  mixins: [PublicComponent],
  data() {
    return {
      Gid: "",
      Columns,
      ColuumnsButton,
      deviceList: [],
      deviceSelections: [],
      seek: {
        deviceSn: "",
        deviceName: "",
        deviceIp: "",
        deviceAddress: "",
        gid: "", // 分组id
        deviceState: "",
        sortNum: "",
      },
      Permission: [],
    };
  },
  activated() {
    if (this.deviceGroup.groupId) {
      this.seek.gid = this.deviceGroup.groupId;
    } else {
      this.seek.gid = "";
    }
    this.queryKeyword();
    this.Permission = getPermission();
  },
  mounted() {
    if (this.deviceGroup.groupId) {
      this.seek.gid = this.deviceGroup.groupId;
    } else {
      this.seek.gid = "";
    }
    this.queryKeyword();
    this.Permission = getPermission();
  },
  beforeDestroy() {
    this.$store.dispatch("setGroup", "");
  },
  computed: {
    ...mapGetters(["deviceGroup"]),
  },
  methods: {
    // 获取设备列表
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        type: 1,
        deviceSn: this.seek.deviceSn ? this.seek.deviceSn : undefined,
        deviceName: this.seek.deviceName ? this.seek.deviceName : undefined,
        deviceIp: this.seek.deviceIp ? this.seek.deviceIp : undefined,
        deviceAddress: this.seek.deviceAddress
          ? this.seek.deviceAddress
          : undefined,
        sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
        gid: this.seek.gid ? this.seek.gid : undefined,
        deviceState: this.seek.deviceState ? this.seek.deviceState : undefined,
      };
      queryDevices(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.deviceList = data.records;
          this.deviceList.unshift({});
          this.total = data.total;
        }
      });
    },
    // 排序
    sortChange(column, prop) {
      if (prop == "deviceSn") {
        if (column.order == "descending") {
          this.seek.sortNum = 2;
        } else {
          this.seek.sortNum = 1;
        }
      } else if (prop == "deviceName") {
        if (column.order == "descending") {
          this.seek.sortNum = 4;
        } else {
          this.seek.sortNum = 3;
        }
      } else if (prop == "deviceIp") {
        if (column.order == "descending") {
          this.seek.sortNum = 6;
        } else {
          this.seek.sortNum = 5;
        }
      } else if (prop == "deviceAddress") {
        if (column.order == "descending") {
          this.seek.sortNum = 8;
        } else {
          this.seek.sortNum = 7;
        }
      } else {
        this.seek.sortNum = "";
      }
    },
    addDevice() {
      this.$refs.addDevice.show(this.deviceGroup);
    },
    //表格状态
    GetStatus(status) {
      return {
        status: status == 3 ? "success" : "danger",
        TagName:
          status == 3
            ? this.$t("lang.devicelist.connected")
            : this.$t("lang.devicelist.not"),
      };
    },
    // 查看详情
    showDetail(row) {
      this.$store.dispatch("setDevice", row);
      this.$router.push({
        path: `/cloudMonitor/deviceManagement/terminalList`,
        // path: `/cloudMonitor/deviceManagement/variableList`,
      });
    },
    // 批量删除
    batchDelete() {
      if (this.deviceSelections <= 0) {
        this.$message.warning(this.$t("lang.DateSelect.message2"));
      } else {
        let deviceIds = this.deviceSelections.map((item) => {
          return item.deviceId;
        });
        let params = {
          deviceIds,
        };
        this.$confirm(
          this.$t("lang.projectList.confirmdeletion"),
          `${this.$t("lang.Button.tips")}`,
          {
            cancelButtonText: `${this.$t("lang.Button.cancel")}`,
            confirmButtonText: `${this.$t("lang.Button.confirm")}`,
          }
        )
          .then(() => {
            deleteDevice(params)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.Button.successDelete"));
                  this.offset = 1;
                  this.queryKeyword();
                  this.$refs.devicesTable.cancelSelect();
                } else {
                  this.$message.error(this.$t("lang.collect.msg8"));
                }
              })
              .catch(() => {});
          })
          .catch(() => {});
      }
    },
    // 刪除
    deleteDevice(row) {
      let params = {
        deviceIds: [row.deviceId],
      };
      deleteDevice(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success(this.$t("lang.Button.successDelete"));
            this.offset = 1;
            this.queryKeyword();
          } else {
            this.$message.error(this.$t("lang.collect.msg8"));
          }
        })
        .catch(() => {});
    },
    // 获取选中项
    handleSelectionChange(val) {
      this.deviceSelections = val;
    },
    // 点击返回，返回到项目列表
    goBack() {
      this.$store.dispatch("setGroup", "");
      this.$router.push({
        path: `/cloudMonitor/deviceManagement/projectGroup`,
      });
    },
    //查看变量
    showVariable() {},
  },
};
</script>
<style scoped></style>
